const idPortalApi = "44b79b0bad11b99d7c9d8522099506b75b1b76fe";

module.exports = {
  idPortalApi: `${idPortalApi}`,
  tokenLink: `${idPortalApi}`, //Token para acessar o WWW.transparência
  // Produção
  urlApi: `https://api-portais-workcenter.com.br/${idPortalApi}`,
  // urlApi: `http://localhost:8004/${idPortalApi}`,
  urlADM: `https://administracaopublica.com.br`,

  dnsPortal: "altoalegredopindare.ma.gov.br",

  NomePortal: "Alto Alegre do Pindaré",
  ufPortal: "MA",
  NomeTipoPortal: "Prefeitura Municipal", //Prefeitura ou Câmara
  TipoPortal: 3, //3 = Prefeitura 4 = Câmara

  //Variável em teste (newsViewRoute)
  newsViewRoute: true, //Essa opção informa se a rota de visualização de uma única noticia está disponível (Raposa gera as noticias pelo lado do servidor com nextjs)

  countNewsHome: 6, //quantidade de noticias na home

  RoutesDaily: true, //Deixa ativado as rotas para a pagina de diario

  link: "http://www.transparenciadministrativa.com.br", //Onde o token abaixo ser[a utilizado]
  linkArquivos: "http://www.transparenciadministrativa.com.br/portalimagem", //Onde o token abaixo ser[a utilizado]

  urlEmDeploy: "https://www.altoalegredopindare.ma.gov.br/", //usada para link de compartilhamento
  imagemURL: "https://cdn.administracaopublica.com.br/complementares/", //link para a imagem
  //imagemURL: 'http://localhost:8004/uploads/', //link para a imagem

  corIcones: "#000080",
  link_youtube: `#`,
  
  link_mapa: `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11157.942520990622!2d-45.850420462890625!3d-3.6684870738282673!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x92ca743473ff3ed1%3A0xca17b19307a82343!2sAlto%20Alegre%20do%20Pindar%C3%A9%2C%20State%20of%20Maranh%C3%A3o%2C%2065398-000!5e0!3m2!1sen!2sbr!4v1744867769629!5m2!1sen!2sbr`,
  link_localize: `https://maps.app.goo.gl/tY1kQGmArQviSpfG6`,
};
